module.exports = __webpack_public_path__ + "static/img/76039A_2_C_20200918_LC.f36f9ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/76039A_2_C_20200918_LC.png
// module id = e6xC
// module chunks = 0